const currentUrl = window.location.href;
const newUrl = currentUrl.replace(/\/en-es(\/?)/, '/es-es$1').replace(/\/en-de(\/?)/, '/de-de$1');
if (newUrl !== currentUrl) {
  window.location.replace(newUrl);
}

  document.addEventListener("DOMContentLoaded", function () {
const observer = new MutationObserver(() => {
  document.querySelectorAll("scrolling-text").forEach(scrollingText => {
    const healcodeLink = scrollingText.querySelector(".healcode-link");

    if (healcodeLink && !scrollingText.dataset.bound) {
      scrollingText.addEventListener("click", function (e) {
        if (e.target.closest(".healcode-link")) return;
        healcodeLink.click();
      });
      scrollingText.style.cursor = "pointer";
      scrollingText.dataset.bound = "true";
    }
  });


document.querySelectorAll("a[data-anchor='schedule-widget'] + a").forEach(button => {
  if (!button.dataset.bound) {
    button.addEventListener("click", function (e) {
      const healcodeLink = document.querySelector("scrolling-text .healcode-link");
      const healcodeLinkAlt = document.querySelector("scrolling-text healcode-widget > a");

      if (healcodeLink) {
        e.preventDefault();
        healcodeLink.click();
      } else if (healcodeLinkAlt) {
        e.preventDefault();
        healcodeLinkAlt.click();
      } else {
        console.warn("No healcode link found to trigger.");
      }
    });
    button.style.cursor = "pointer";
    button.dataset.bound = "true";
  }
});




});

observer.observe(document.body, { childList: true, subtree: true });



    document.querySelectorAll('a[data-anchor="schedule-widget"]').forEach(anchor => {
      anchor.addEventListener("click", function(e) {
        e.preventDefault();
        document.querySelector(".mindbody-widget[data-widget-type=Schedules]").scrollIntoView({
          behavior: "smooth"
        });
      });
    });

    document.querySelectorAll('a[data-anchor="buy_page"]').forEach(anchor => {
      anchor.addEventListener("click", function(e) {
        e.preventDefault();

        const target = document.querySelector(".buy_page");
        const offset = 100;
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth"
        });
      });
    });

  });

